/* eslint-disable no-alert */
import * as HTMLElementCreator from '../../../libs/HTML/HTMLElementCreator';
import type { LevelData } from '../../../game/level/LevelData';
import type { EditorPanel, EditorPanelStateChangeCallback } from './types';
import { createEditorInput, type EditorInputField } from '../utils/createEditorInput';
import { SECTION_LABEL_STYLE } from '../EditorOverlayStyles';
import { EditorGoalsPanel } from './subPanels/EditorGoalsPanel';
import { EditorRefillsPanel } from './subPanels/EditorRefillsPanel';

export class EditorLevelPropertiesPanel implements EditorPanel {
  public readonly element: HTMLElement;

  private readonly reward: EditorInputField;

  private readonly goalPanel: EditorGoalsPanel;

  private readonly refillsPanel: EditorRefillsPanel;

  constructor(private readonly onStateUpdate: EditorPanelStateChangeCallback) {
    this.element = HTMLElementCreator.createDiv({
      elementID: 'editor-properties-panel',
      parentElement: undefined,
      style: {
        position: 'fixed',
        top: '50px',
        right: '5px',
        padding: '2px 2px 2px 2px',
        color: 'black',
        minWidth: '200px',
        minHeight: '500px',
        backgroundColor: 'rgba(0,0,0,0.25)',
        pointerEvents: 'auto',
      },
    });

    HTMLElementCreator.createLabel({
      parentElement: this.element,
      labelText: 'Level Properties',
      style: { ...SECTION_LABEL_STYLE },
    });

    this.goalPanel = this.createGoalPanel();
    this.reward = this.createRewardInput();
    this.refillsPanel = this.createRefillsPanel();
  }

  public destroy(): void {
    this.element.remove();
  }

  public focus(): void {
    this.element.style.visibility = 'visible';
  }

  public blur(): void {
    this.element.style.visibility = 'hidden';
  }

  private createGoalPanel(): EditorGoalsPanel {
    const panel = new EditorGoalsPanel(this.onStateUpdate);
    this.element.appendChild(panel.element);
    return panel;
  }

  private createRewardInput(): EditorInputField {
    const rewardInput = createEditorInput({
      parentElement: this.element,
      labelText: 'Reward ',
      restrictRegEx: /^\d+$/,
      onValueChanged: (value: string) => {
        this.onStateUpdate({
          reward: parseInt(value, 10),
        });
      },
    });
    Object.assign(rewardInput.label.style, { ...SECTION_LABEL_STYLE });

    return rewardInput;
  }

  private createRefillsPanel(): EditorRefillsPanel {
    const panel = new EditorRefillsPanel(this.onStateUpdate);
    this.element.appendChild(panel.element);
    return panel;
  }

  public update(levelData: LevelData): void {
    this.reward.input.value = `${levelData.reward}`;
    this.refillsPanel.update(levelData.refills);
    this.goalPanel.update(levelData.goal);
  }
}
